import { NavLink, Outlet, Route, Routes, useLocation, Navigate} from "react-router-dom";
import RolfingLibrary from "./templatelibrary/RolfingLibrary";
import PulseLibrary from "./templatelibrary/PulseLibrary";

export default function TemplateLibrary() {

    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                 <Route index element={<Navigate to="rolfing" replace />} />
                <Route path="rolfing" element={<RolfingLibrary />} />
                <Route path="pulse" element={<PulseLibrary />} />
            </Route>
        </Routes>
    );
}

const Layout = () => {
    const { pathname } = useLocation();

    return (
        <>
            <h2>Template Library</h2>
            <div className='grid-container nowrap'>
            <nav className="organisationMenu">
                <ul className="nav">
                    <li>
                        <NavLink end to="rolfing" className={({ isActive }) => (isActive || pathname.includes("rolfing")) ? "active" : undefined}>Rolfing Templates</NavLink>
                    </li>
                    <li>
                        <NavLink to="pulse" className={({ isActive }) => isActive ? 'active' : undefined }>Pulse Templates</NavLink>
                    </li>
                </ul>
            </nav>
            <Outlet />
        </div>
        </>
    )
}
